function Footer(props) {
    return (
        <div className="footer">
            <img className="mountains" src="https://res.cloudinary.com/dhbumhhh1/image/upload/v1643571237/my-sustainable-brand/footer_tkqqol.png" alt="mountains" />
        </div>
    )
}

export default Footer;